<script setup lang="ts">
    import { reactive, onMounted } from 'vue';
    import { getSentIssueStatistics } from './Issues.access';
    import { type IssueStatistics } from './interfaces';
    import ListItemSentStats from './ListItemSentStats.vue';

    const emit = defineEmits<{
        (ev: 'issueStatisticsLoaded', issue: IssueStatistics): void;
    }>();

    const { issueId, resendToExistingRecipients, storedIssueStatistics } = defineProps<{
        issueId: string;
        resendToExistingRecipients: boolean;
        storedIssueStatistics: {
            [key: string]: IssueStatistics;
        };
    }>();

    const state = reactive<{
        issueStatistics: IssueStatistics | null;
        loading: boolean;
    }>({
        issueStatistics: null,
        loading: true,
    });

    onMounted(async () => {
        if (storedIssueStatistics[issueId]) {
            state.issueStatistics = storedIssueStatistics[issueId];
            state.loading = false;
            return;
        }

        state.issueStatistics = await getSentIssueStatistics(issueId);
        emit('issueStatisticsLoaded', state.issueStatistics);
        state.loading = false;
    });
</script>

<template>
    <div v-if="resendToExistingRecipients" class="align-self-center m-xs-b" style="max-width: 600px">
        {{ $Resources.DisableIssueStatisticsResendToExistingRecipients }}
    </div>

    <div class="align-self-center">
        <ListItemSentStats :loading="state.loading" :issueStatistics="state.issueStatistics" />
    </div>
</template>
